<!--
/*
 * This file is part of peacohrm Inc
 *
 * Copyright (C) 2020 onwards peacohrm Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <g transform="matrix(0.976563, 0, 0, 0.976563, 0, 0)">
    <path
      d="M422,332H90c-49.626,0-90,40.374-90,90v90h512v-90C512,372.374,471.626,332,422,332z M274.289,392h-36.577l-7.5-30h51.578   L274.289,392z M210.691,407.611L198.293,482H136V362h63.289L210.691,407.611z M238.707,422h34.586l10,60h-54.586L238.707,422z    M301.309,407.611L312.711,362H376v120h-62.293L301.309,407.611z M30,422c0-33.084,26.916-60,60-60h16v120H30V422z M482,482h-76   V362h16c33.084,0,60,26.916,60,60V482z"
    />
    <path
      d="M256,302c83.262,0,151-67.738,151-151S339.262,0,256,0S105,67.738,105,151S172.738,302,256,302z M256,30   c66.72,0,121,54.28,121,121s-54.28,121-121,121s-121-54.28-121-121S189.28,30,256,30z"
    />
    <polygon points="347,136 271,136 271,60 241,60 241,166 347,166  " />
  </g>
</template>
